module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABEElEQVQ4T5XSu0peURCG4WfSiCh4ugIPWNtYiljYWCQ2WhkEBSFFLkDERgRvQFsbSxWRYG1vYyfY6AVIRCRouWRk/7L52VvMNGsxM+8why/UrJQygl/4jokqdI8/OIiIh056dD6llAUcYbherPZ/wlpEnKXvHaygiy7gFb0NRZYi4iRKKUPIdga6kuaxipUu/zNGE9zGTkPluQpab4jtJniNqRbwZ87VELtJMIfubjNzZzGJmQrsxyK+4V+Cf1s2uYnLzgLRh1xgD14SvMJ0ywna3LcJbmH3P8G9BAerc+T7FctzjH0mgLYiyxFxXJdc6vMQqdcme8RGRJx+SK6m11TRb/zAeOW/wzn2IyIv8G5vDPxRul3RlvUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taskPlan/deliveryTime.png
// module id = iHzf
// module chunks = 2